import React, { Fragment } from 'react';
import { Route, useLocation } from 'react-router-dom';
import { rememberPostLoginRedirect } from 'utils/url';
import { useAuth } from 'react-oidc-context';
import { NotAuthenticated } from 'components/NotAuthenticated';
import { NotAuthorized } from 'components/NotAuthorized';

// React Router's `<Switch>` picks the FIRST matching route and ignores the rest.
// RequireAuth sits inside the <Route>'s render. 
// It only executes after React Router has already decided that /account/profile matches.

const RequireAuth = ({ children }) => {
  const auth = useAuth();
  const { pathname } = useLocation();

  if (auth.error) return <NotAuthorized />;
  if (auth.isLoading || auth.activeNavigator) return null;

  if (!auth.isAuthenticated && pathname === '/account/verify-phone') return (
    <div className="container p-5">
      <p>Sign in with the same ChatCLB account connected to ChatGPT to verify your phone.</p>
      <button className="button is-info" onClick={() => {
        rememberPostLoginRedirect(pathname);
        auth.signinRedirect();
      }}>Sign in</button>
    </div>
  );
  return auth.isAuthenticated ? children : <NotAuthenticated />;
};

export const ApolloRoute = ({ ...props }) => {
  const { component: Component, secure, isNavbarHide, profile, ...rest } = props;

  // const profile = useProfile();
  // useGetAllAppointments()
  // const { pathname } = useLocation();

  // let isAllowFooter = false;
  // if (!profile.isLoggedIn) {
  //   isAllowFooter = pathname !== '/';
  // } else {
  //   isAllowFooter =
  //     !String(pathname).includes('/admin') &&
  //     !String(pathname).includes('/superadmin') &&
  //     !String(pathname).includes('/messages') &&
  //     !String(pathname).includes('/business/search');
  // }

  // if (String(pathname).includes('/notifications')) {
  //   refetch()
  // }

  return (
    <Fragment>
      {/* {loading && <FullPageLoader />} */}
      {/* {!isNavbarHide && <NavMenu />} */}
      <Route
        {...rest}
        render={(props) =>
          secure ? (
            <RequireAuth>
              <Component {...profile} {...props} />
            </RequireAuth>
          ) : (
            <Component {...profile} {...props} />
          )
        }
      />
      {/* {isAllowFooter && <Footer />} */}
    </Fragment>
  );
};
